/* Collection infinite scroll
   Auto-loads next pages as the user scrolls until `data-auto-pages`
   pages have been auto-loaded; then switches to a click-to-load button. */
(function () {
  var sentinel = document.querySelector('[data-grid-sentinel]');
  if (!sentinel) return;

  var grid = document.querySelector('.product-grid');
  if (!grid) return;

  var autoPagesMax = parseInt(sentinel.dataset.autoPages || '10', 10);
  var autoPagesLoaded = 0;
  var loading = false;
  var nextUrl = sentinel.dataset.nextUrl || '';
  var status = sentinel.querySelector('.collection-infinite__status');
  var button = sentinel.querySelector('.collection-infinite__button');
  var observer = null;

  function showStatus() {
    if (status) status.hidden = false;
    if (button) button.hidden = true;
  }
  function showButton() {
    if (button) button.hidden = false;
    if (status) status.hidden = true;
  }
  function hideAll() {
    if (button) button.hidden = true;
    if (status) status.hidden = true;
    sentinel.hidden = true;
  }

  function startObserving() {
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting && !loading && nextUrl) {
          observer.unobserve(sentinel);
          loadNext();
        }
      }, { rootMargin: '600px 0px' });
    }
    observer.observe(sentinel);
  }

  function loadNext() {
    if (loading || !nextUrl) return;
    loading = true;
    showStatus();

    var url = nextUrl;
    fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newCards = doc.querySelectorAll('.product-grid .product-card');
        if (!newCards.length) {
          hideAll();
          nextUrl = '';
          loading = false;
          return;
        }
        var frag = document.createDocumentFragment();
        newCards.forEach(function (c) { frag.appendChild(c); });
        grid.appendChild(frag);

        try { history.replaceState({}, '', url); } catch (e) {}

        var newSentinel = doc.querySelector('[data-grid-sentinel]');
        nextUrl = newSentinel ? (newSentinel.dataset.nextUrl || '') : '';
        loading = false;

        if (!nextUrl) { hideAll(); return; }

        autoPagesLoaded += 1;
        if (autoPagesLoaded < autoPagesMax) {
          showStatus();
          startObserving();
        } else {
          if (observer) observer.unobserve(sentinel);
          showButton();
        }
      })
      .catch(function () {
        loading = false;
        if (observer) observer.unobserve(sentinel);
        showButton();
      });
  }

  if (!nextUrl) {
    hideAll();
    return;
  }

  if (autoPagesMax > 0) {
    showStatus();
    startObserving();
  } else {
    showButton();
  }

  if (button) {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      loadNext();
    });
  }
})();
